export const genMaterialData = (element, background) => {
  const data = {};
  if (element) {
    data.elementTypeId = element.materialTypeId || element.material_type_id || element.typeId;
    data.elementId = element.id;
    data.elementImg = element.src;
  }
  if (background) {
    data.backgroundId = background.id;
    data.bgParameter = {
      src: background.src,
      tagBgColor: background.tagBgColor,
      textShadowColor: background.textShadowColor,
    };
  }
  return data;
};
export const isPortraitMaterialType = typeId => [3, 7].includes(Number(typeId));
export const hasMaterialId = id => {
  if (id === undefined || id === null || id === "" || id === "undefined" || id === "null") return false;
  const n = Number(id);
  return Number.isFinite(n) && n > 0;
};
// 随机选中数组中的一个元素
export const randomItemOfArr = (arr, id) => {
  if (!arr || !arr.length) return undefined;
  if (hasMaterialId(id)) {
    const d = arr.find(item => Number(item.id) === Number(id));
    if (d) return d;
  }
  const index = Math.floor(arr.length * Math.random());
  return arr[index];
};
export const materialUrl = src => {
  if (!src) return "";
  const value = String(src).trim();
  if (/^(https?:)?\/\//.test(value) || value.startsWith("data:")) return value;
  return `//bar.xkw.com${value}`;
};
export const normalizeMaterialSrc = src => {
  if (!src) return "";
  const value = String(src).trim();
  if (/^(https?:)?\/\//.test(value)) {
    try {
      const url = new URL(value.startsWith("//") ? `https:${value}` : value);
      return url.pathname.replace(/\/{2,}/g, "/");
    } catch (error) {
      return value.replace(/^(https?:)?\/\/[^/]+/, "").replace(/\/{2,}/g, "/");
    }
  }
  return value;
};
const withMaterialColor = (material, color) => {
  if (!material || !color) return material;
  return {
    ...material,
    tagBgColor: material.tagBgColor || color.tagBgColor,
    textShadowColor: material.textShadowColor || color.textShadowColor,
  };
};
// 做同款：优先用原素材 id，找不到再用原图，最后用排序最靠前的
export const pickMaterial = (arr, id, fallbackSrc, color) => {
  if (hasMaterialId(id) && Array.isArray(arr)) {
    const found = arr.find(item => Number(item.id) === Number(id));
    if (found) return withMaterialColor(found, color);
  }
  if (fallbackSrc) {
    return withMaterialColor(
      {
        id: hasMaterialId(id) ? Number(id) : 0,
        src: normalizeMaterialSrc(fallbackSrc),
      },
      color
    );
  }
  return arr && arr[0];
};
// 每被使用一次，排序上相当于往前推 14 天
export const MATERIAL_USE_PENALTY_MS = 14 * 24 * 60 * 60 * 1000;
// 新素材靠前，使用次数多的靠后
export const sortMaterialsByFreshness = list => {
  if (!Array.isArray(list)) return [];
  return list.slice().sort((a, b) => {
    const rankA = Number(a && a.rank);
    const rankB = Number(b && b.rank);
    if (Number.isFinite(rankA) && Number.isFinite(rankB) && rankA !== rankB) {
      return rankB - rankA;
    }
    const timeA = new Date((a && (a.uploadTime || a.upload_time)) || 0).getTime() || 0;
    const timeB = new Date((b && (b.uploadTime || b.upload_time)) || 0).getTime() || 0;
    const countA = Number((a && (a.useCount || a.use_count)) || 0);
    const countB = Number((b && (b.useCount || b.use_count)) || 0);
    return timeB - countB * MATERIAL_USE_PENALTY_MS - (timeA - countA * MATERIAL_USE_PENALTY_MS);
  });
};
// 按当前排序取靠前、且不是正在使用的一项，方便换一换时仍优先新素材
export const freshItemOfArr = (arr, currentId) => {
  if (!arr || !arr.length) return undefined;
  if (hasMaterialId(currentId)) {
    const next = arr.find(item => Number(item.id) !== Number(currentId));
    if (next) return next;
  }
  return arr[0];
};
// 从全部素材里随机取一张，尽量避开当前正在使用的
export const randomItemExcept = (arr, currentId) => {
  if (!arr || !arr.length) return undefined;
  const pool = hasMaterialId(currentId)
    ? arr.filter(item => Number(item.id) !== Number(currentId))
    : arr;
  const source = pool.length ? pool : arr;
  return source[Math.floor(source.length * Math.random())];
};
// 对素材随机排序
export const randomSort = list => {
  return list.sort(() => {
    return Math.random() > 0.5 ? -1 : 1;
  });
};
// 文字的标签样式
export const getLabelStyleMenu = function (themeColor) {
  themeColor = themeColor || "#D6DBE0";
  themeColor = themeColor.includes(",") ? themeColor : `${themeColor}, ${themeColor}`;
  let labelStyleMenu = {
    1: {
      name: "样式1",
      id: 1,
      style: {
        borderRadius: "2em",
        background: `linear-gradient(90deg, ${themeColor})`,
      },
    },
    2: {
      name: "样式2",
      id: 2,
      style: {
        background: `linear-gradient(90deg, ${themeColor})`,
        borderRadius: "2px",
      },
    },
    3: {
      name: "样式3",
      id: 3,
      style: {
        border: "1px solid #fff",
        borderRadius: "2em",
        background: "transparent",
      },
    },
    4: {
      name: "样式4",
      id: 4,
      style: {
        border: "1px solid #fff",
        background: "transparent",
        borderRadius: "2px",
      },
    },
    5: {
      name: "样式5",
      id: 5,
      style: {
        background: `linear-gradient(90deg, ${themeColor})`,
        border: "1px solid #fff",
        borderRadius: "2em",
      },
    },
  };
  return labelStyleMenu;
};

// 文字的标签样式
export const getSurnameStyleMenu = function (themeColor) {
  themeColor = themeColor || "#D6DBE0";
  themeColor = themeColor.includes(",")
    ? themeColor
    : `${themeColor}, ${themeColor}`;
  let labelStyleMenu = {
    1: {
      name: "样式1",
      id: 1,
      style: {
        borderRadius: "2em",
        background: `linear-gradient(90deg, ${themeColor})`,
      },
    },
    2: {
      name: "样式2",
      id: 2,
      style: {
        background: `linear-gradient(90deg, ${themeColor})`,
        borderRadius: "2px",
      },
    },
    5: {
      name: "样式5",
      id: 5,
      style: {
        background: `linear-gradient(90deg, ${themeColor})`,
        border: "1px solid #fff",
        borderRadius: "2em",
      },
    },
  };
  return labelStyleMenu;
};
export const hexToRgba = (hex, alpha = 1) => {
  // 移除 # 符号
  hex = hex.replace("#", "");

  // 解析 RGB 值
  const r = parseInt(hex.substring(0, 2), 16);
  const g = parseInt(hex.substring(2, 4), 16);
  const b = parseInt(hex.substring(4, 6), 16);

  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
}

export const navs = {
  'main-navs': [
    {
      name: 'Banner',
      listName: 'banner',
      value: 'banner',
      link: '/banner/build?rebuild=true',
      listLink: '/banner/list',
      isInnerJump: true,
    },
    {
      name: '专题页',
      listName: '专题页',
      value: 'topic',
      link: '/subject-page/business-line',
      listLink: '/aipage/list',
      isInnerJump: false,
    },
    {
      name: '封面',
      listName: '封面',
      value: 'cover',
      link: '/cover/size?rebuild=true',
      listLink: '/cover/list',
      isInnerJump: true,
    },
    {
      name: '海报',
      listName: '海报',
      value: 'poster',
      link: '/poster/build?rebuild=true',
      listLink: '/poster/list',
      isInnerJump: true,
    },
  ],
  'sub-navs': [
    {
      name: '弹窗',
      listName: '弹窗',
      value: 'popup',
      link: '/popup/build',
      listLink: '/popup/list',
      isInnerJump: true,
    },
    {
      name: '皮肤',
      listName: '皮肤',
      value: 'skin',
      link: '/skin/build?rebuild=true',
      listLink: '/skin/list',
      isInnerJump: true,
    },
    {
      name: '公众号次图',
      listName: '公众号次图',
      value: 'sub-cover',
      link: '/sub-cover/build?rebuild=true',
      listLink: '/sub-cover/list',
      isInnerJump: true,
    },
  ],
  'ai-navs': [
    {
      name: '智绘小博士',
      value: 'xbs',
      link: 'xbsphoto',
      isInnerJump: true,
    },
    {
      name: 'AI帮我做',
      value: 'ai',
      link: 'ai/guide',
      isInnerJump: true,
    }
  ],
}

// 下拉菜单与「我的设计」Tab 共用同一顺序
export const DESIGN_NAV_ORDER = ['banner', 'cover', 'topic', 'poster', 'skin', 'sub-cover', 'popup'];

const DESIGN_LIST_PATH_MAP = {
  banner: '/banner/list',
  cover: '/cover/list',
  topic: '/aipage/list',
  poster: '/poster/list',
  skin: '/skin/list',
  'sub-cover': '/sub-cover/list',
  popup: '/popup/list',
  aipage: '/aipage/list',
  'subject-page': '/aipage/list',
};

export const getDesignNavs = () => {
  const all = [...navs['main-navs'], ...navs['sub-navs']];
  return DESIGN_NAV_ORDER.map(value => all.find(item => item.value === value)).filter(Boolean);
};

export const getDesignListPath = (routePath = '') => {
  const segment = routePath.replace(/\/$/, '').split('/')[1];
  return DESIGN_LIST_PATH_MAP[segment] || '/banner/list';
};

export const isMyDesignPage = (routePath = '') => {
  return /^\/(banner|cover|poster|skin|sub-cover|popup|aipage)\/list\/?$/.test(routePath);
};

export const toolsNavs = [
  {
    name: '产研铭牌',
    link: '/nameplate',
    isInnerJump: true,
  },
  {
    name: '展会邀请函',
    link: '/invite-poster',
    isInnerJump: true,
  },
  {
    name: '动效表情',
    link: '/tools/emotions',
    isInnerJump: true,
  },
  {
    name: '课件助手',
    link: '/ued-ppt/courseware/home',
    isInnerJump: true,
  },
  {
    name: '图片压缩',
    link: '/imgmin',
    isInnerJump: true,
  },
  {
    name: '规范查询',
    link: '/standard',
    isInnerJump: true,
  },
]
